import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Alert, Form } from 'reactstrap';
import { BiChevronsLeft, BiMailSend } from 'react-icons/bi';
import InputField from '../InputField';
import { sendPasswordResetLink } from 'layouts/Landing/newAuthService';
import SLButton from 'atoms/SLButton/SLButton';
import '../Login/Login.scss';
import { emailRex, GROUPM_EMAIL_DOMAIN, GROUPM_ERROR_MESSAGE } from 'commons/constants';
import { verifyEmail } from '../utils';

const ForgotPassword = () => {
  const { register, handleSubmit, errors, watch, setValue } = useForm({mode: 'onBlur'});
  const [errorMessage, setErrorMessage] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);
  const watchEmail = watch('email',"");

  const handleEmailChange = (email) => {
    setValue('email', email);
  };

  const onSubmit = (values) => {
    console.log('submit', values);
    sendPasswordResetLink(values.email).then((res) => {
      if (res && res.data && res.data.status && res.data.id) {
        setIsEmailSent(true);
        setErrorMessage('');
      } else {
        setErrorMessage(res.data.id.message || 'Please try again later');
      }
    });
  };

  const toggle =()=>{
    setErrorMessage('')
    handleEmailChange("")
  }

  useEffect(() => {
    if (verifyEmail(watchEmail) && watchEmail && watchEmail.toLowerCase().includes("@")) {
      const emailDomain = watchEmail.toLowerCase().split('@')[1];
      const isGroupMEmail = emailDomain === GROUPM_EMAIL_DOMAIN;
    if (isGroupMEmail) {
      setErrorMessage(`${GROUPM_ERROR_MESSAGE} in Login Page`);
    }else{
      setErrorMessage('')
    }
  }else{
    setErrorMessage('')
  }
  }, [watchEmail]);

  return (
    <div className="mx-4 px-2">
      {!isEmailSent ? (
        <>
          {errorMessage && (
            <Alert color="danger" toggle={toggle}>
              {errorMessage}
            </Alert>
          )}

          <p className="text-center">
            Enter your registered Email Address to reset password
          </p>

          <Form onSubmit={handleSubmit(onSubmit)} className="">
            <InputField
              type="email"
              placeholder="Email"
              name="email"
              error={errors.email}
              ref={register({
                required: 'Email is required',
                pattern: {
                  value: emailRex,
                  message: 'Invalid Email address',
                },
              })}
            />

            <SLButton disabled={errorMessage.length>0} type="submit" block className="mb-3">
              Send Password Reset Link
            </SLButton>
          </Form>
        </>
      ) : (
        <div className="text-center">
          <BiMailSend size={100} style={{ color: '#6bd098' }} />
          <p>
            Password reset link has been sent to your email. Please check your
            mailbox!
          </p>
        </div>
      )}

      <div className="text-center mt-5">
        <Link to="/auth/login" className="link">
          <BiChevronsLeft size={18} /> Go back to Login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
